import {isStringArray} from '@Components/ai-chat-window/lib/stream-component-prop-guards';
import {assetOptionName} from '@Components/ai-chat-window/components/survey/survey.library';
import type {SurveyOption} from '@Components/ai-chat-window/components/survey/survey.types';

export function toggleValue(current: string[], value: string): string[] {
  if (current.includes(value)) {
    return current.filter((entry) => entry !== value);
  }

  return [...current, value];
}

export function selectedValues(fieldValue: unknown): string[] {
  return isStringArray(fieldValue) ? fieldValue : [];
}

export function accessibleAssetName(option: SurveyOption): string {
  return option.isVideo === true ? `${assetOptionName(option)}, ${window.i18next.t('pmwjs_video')}` : assetOptionName(option);
}
